import { Pipe, PipeTransform } from '@angular/core';
import { ChartModel } from '../models/chart-model';

@Pipe({
    name: 'filterCharts'
})

  /**
   * Filter charts on isClassificationSportive
   * @param {any[]} array
   * @param {number} value
   * @returns {any}
   */
export class FilterChartsPipe implements PipeTransform {
    transform(items: ChartModel[], filter: boolean): any {
        if (!items) {
            return items;
        }
        return items.filter(item => item.isSportiveClassification === filter);
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/filter-charts.ts